import { render } from "./FilterResults.vue?vue&type=template&id=454a50aa"
import script from "./FilterResults.vue?vue&type=script&lang=js"
export * from "./FilterResults.vue?vue&type=script&lang=js"

import "./FilterResults.vue?vue&type=style&index=0&id=454a50aa&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__